<template>
  <div>
    <list
      row-key="Id"
      ref="list"
      unit="模具档案"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :get-data-func="getDataFunc"
      :query-params="params"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ba/mould").default,
      params: {
        
      },
    };
  },
  methods: {
    getDataFunc(params = {}) {
      return new Promise((resolve) => {
          resolve({ Count: 1, Data: [
            { Id: 1, mjbm: "MJ25003", mjlb: "眼影盒模具", lx: 0, zqs: 4, zks: 1, cz: "PVC", zq: "ABS", skz: "10", nqgg: "1出1腔", syjtxh: "M001", khmc: "客户1", Status: 0 }
          ]});
      });
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(this.params).then(() => {
        loading.close();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>